export default __webpack_public_path__ + "static/media/img_toma.eab12155.png";